import * as angular from "angular";
import { ChartHelper } from "../../../result/chart.helper";
import chroma from "chroma-js";
import { CanvassStatus } from "../../../../models/canvass-status.model";
import { CanvassStatusDataProvider } from "../../../../data-provider/canvass-status.dp";
import { NEW_CONTACTS_GROUP_BY } from "../new-contacts-metrics";

let WidgetColorDropdownComponent = {
    selector: "vcWidgetColorDropdown",
    templateUrl:
        "/angular/components/dashboard/widget/style/widget-color-dropdown.component.html",
    bindings: {
        widget: "=",
    },
    controller: class WidgetColorDropdownController {
        // * bindings for typescript compiler *
        public widget: any;
        // ************************************

        public chartHelper: ChartHelper;
        public disabled: ChartHelper;
        public statusPalette = {
            key: "canvass_statuses",
            name: "Canvass Status Colors",
            colors: [],
        };

        constructor(
            $scope: any,
            __app_type: string,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            ChartHelper: ChartHelper
        ) {
            this.chartHelper = ChartHelper;

            CanvassStatusDataProvider.walkCanvassStatuses().then(
                (statuses: CanvassStatus[]) => {
                    angular.forEach(statuses, (status: CanvassStatus) => {
                        if (!this.statusPalette.colors.includes(status.color)) {
                            this.statusPalette.colors.push(status.color);
                        }
                    });
                }
            );
        }

        isGroupedByStatus(): boolean {
            return (
                !!this.widget &&
                ["interaction_status", NEW_CONTACTS_GROUP_BY].includes(this.widget.groupby)
            );
        }

        selectPalette(palette: any) {
            this.widget.style.colorPalette = palette;
        }

        generateColors(palette: any, numberColors?: number) {
            if (this.isGroupedByStatus()) {
                return this.statusPalette.colors;
            } else {
                return chroma
                    .scale(palette.colors)
                    .mode("lch")
                    .colors(numberColors ?? 5);
            }
        }
    },
};

angular
    .module("dashboard")
    .component(
        WidgetColorDropdownComponent.selector,
        WidgetColorDropdownComponent
    );
